/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CreateApiKeyBody = zod
	.object({
		name: zod.string().describe('API key name')
	})
	.describe('Request body for creating an API key');

export type CreateApiKeyBody = zod.input<typeof CreateApiKeyBody>;
export type CreateApiKeyBodyOutput = zod.output<typeof CreateApiKeyBody>;
